import React from "react"
import PropTypes from "prop-types"
import { Spacer } from "@bw/bits"
import { TeaserList } from "@bw/partials"

const ListOfJobs = ({ jobs }) => {
  if (jobs.length === 0) {
    return null
  }

  return jobs.map(job => (
    <TeaserList
      key={job.id}
      to={job.url}
      title={job.title}
      subtitle={`${job.getDuration()} - ${job.occupancyRate}`}
    />
  ))
}

ListOfJobs.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.object),
}

ListOfJobs.defaultProps = {
  jobs: [],
}

export { ListOfJobs }
